import styled from "styled-components";

interface ReportModalProps{
    isOpen:boolean,
    value:string,
    type:string,
    onDeleteClickHandler:() => void
    onCancelClickHandler:() => void
}

const FilePreviewModal = ({isOpen, value, type, onDeleteClickHandler, onCancelClickHandler}:ReportModalProps) => {
    if(!isOpen){
        return null;
    }
    return(
        <Container>
            <Modal>
                <TitleWrap>
                    <Title>파일 미리보기</Title>
                </TitleWrap>
                {type === "image" ? <Img src={value} alt="preview"/> : <Video src={value} controls/>}
                <ButtonWrap>
                    <ButtonCancel onClick={onDeleteClickHandler}>삭제</ButtonCancel>
                    <Button onClick={onCancelClickHandler}>닫기</Button>
                </ButtonWrap>
            </Modal>
        </Container>
    )
}

const Container = styled.div`
   position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;
`

const Modal = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    padding: 16px;
    width: 400px;
    min-width: 300px;
    background-color: white;
    border-radius: 16px;
    animation: fadeInUp 0.5s ease-in-out;
`

const TitleWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Title = styled.div`
  text-align: center;
  font-size: 24px;
`;


const ButtonWrap = styled.div`
    display: flex;
    gap: 20px;
    align-items: center;
`

const Button = styled.button`
    height: 50px;
    padding: 0 40px;
    background-color: #df0000;
    color: white;
    border: none;
    border-radius: 52px;
    cursor: pointer;
    font-size: 16px;
    font-weight: bold;
    transition: 0.3s;
`;

const ButtonCancel = styled.button`
    height: 50px;
    padding: 0 40px;
    background-color: white;
    color: #df0000;
    border: 1px solid #df0000;
    border-radius: 52px;
    cursor: pointer;
    font-size: 16px;
    font-weight: bold;
    transition: 0.3s;
`

const Video = styled.video`
    width: 100%;
`

const Img = styled.img`
    width: 100%;
`

export default FilePreviewModal;